/**
 * @generated SignedSource<<05546baeda707fa8254cce4899f3d0e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BulkCreateDepartmentsInput = {
  companyId?: string | null;
  departments?: ReadonlyArray<DepartmentInput | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DepartmentInput = {
  name?: string | null;
};
export type bulkCreateDepartmentsMutation$variables = {
  input: BulkCreateDepartmentsInput;
};
export type bulkCreateDepartmentsMutation$data = {
  readonly bulkCreateDepartments: {
    readonly departments: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
      } | null;
    } | null> | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type bulkCreateDepartmentsMutation = {
  variables: bulkCreateDepartmentsMutation$variables;
  response: bulkCreateDepartmentsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BulkCreateDepartmentsPayload",
    "kind": "LinkedField",
    "name": "bulkCreateDepartments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DepartmentTypeEdge",
        "kind": "LinkedField",
        "name": "departments",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DepartmentType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkCreateDepartmentsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bulkCreateDepartmentsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8cebba51905f35e14a5095f7c32b023a",
    "id": null,
    "metadata": {},
    "name": "bulkCreateDepartmentsMutation",
    "operationKind": "mutation",
    "text": "mutation bulkCreateDepartmentsMutation(\n  $input: BulkCreateDepartmentsInput!\n) {\n  bulkCreateDepartments(input: $input) {\n    departments {\n      node {\n        id\n        name\n      }\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "169a4c001c5c4c56b5bee5a79ac7dee2";

export default node;
